/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Recommendation Video Component
 *
 * @file ChannelsPracticeCard.jsx
 * @author Murhsid Ahamedh
 */

import React from 'react';
import PropTypes from 'prop-types';

import { ChannelsPracticeCard, ChannelsProvider } from '@study/components';
import PracticeCardClasses from './ChannelsPracticeCardStyle';

/**
 * ChannelsPracticeRecommendationCard
 * Thin wrapper around @study/components ChannelsPracticeCard with
 * sensible defaults for our eText context.
 */
const ChannelsPracticeRecommendationCard = ({
  asset,
  env,
  channelId,
  trackingGlobalData,
  onSeeInChannelsLinkClick,
  user
}) => {
  const practiceConfig = React.useMemo(() => ({
    cardHeadText: 'Problem',
    buttonText: 'View answer in Study Prep',
    linkText: 'Answer in Study Prep',
    playMode: false
  }), []);

  return (
    <ChannelsProvider channelId={channelId} env={env} user={user}>
      <ChannelsPracticeCard
        key={asset?.id}
        asset={asset}
        source="eTextMiniplayer_PracticeProblem"
        channelId={channelId}
        env={env}
        trackingGlobalData={trackingGlobalData}
        classes={PracticeCardClasses}
        config={practiceConfig}
        onSeeInChannelsLinkClick={(url, event) => {
          if (onSeeInChannelsLinkClick) onSeeInChannelsLinkClick(url, event);
        }}
      />
    </ChannelsProvider>
  );
};

ChannelsPracticeRecommendationCard.propTypes = {
  asset: PropTypes.object.isRequired,
  env: PropTypes.string.isRequired,
  channelId: PropTypes.string.isRequired,
  trackingGlobalData: PropTypes.object,
  onSeeInChannelsLinkClick: PropTypes.func,
  user: PropTypes.object.isRequired
};

ChannelsPracticeRecommendationCard.defaultProps = {
  trackingGlobalData: {},
  onSeeInChannelsLinkClick: () => {}
};

export default ChannelsPracticeRecommendationCard;

